/**
 * Sewphee Amazon buy buttons — variant-aware link swap.
 * Reads the per-variant ASIN map rendered by
 * snippets/sewphee-amazon-buttons.liquid and keeps the two marketplace
 * buttons in sync with the shopper's variant selection and remembered
 * marketplace preference. No dependencies, no analytics binding here.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'sewphee:marketplace';
  var ROOT_SELECTOR = '[data-sewphee-amazon-buttons]';
  var CTA_SELECTOR = '[data-sewphee-amazon-cta]';

  function getStoredMarketplace() {
    try {
      var value = window.localStorage.getItem(STORAGE_KEY);
      if (value === 'ca' || value === 'us') {
        return value;
      }
    } catch (error) {
      // localStorage unavailable (privacy mode, disabled storage, etc.) — ignore.
    }
    return null;
  }

  function setStoredMarketplace(marketplace) {
    try {
      window.localStorage.setItem(STORAGE_KEY, marketplace);
    } catch (error) {
      // localStorage unavailable — the block still renders, preference just isn't kept.
    }
  }

  function defaultFromCountry(iso) {
    return iso === 'US' ? 'us' : 'ca';
  }

  function parseVariantData(root) {
    var script = root.querySelector('[data-sewphee-amazon-variants]');
    if (!script) {
      return {};
    }
    try {
      return JSON.parse(script.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  function applyPrimary(root, marketplace) {
    var buttons = root.querySelectorAll(CTA_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var isPrimary = button.getAttribute('data-marketplace') === marketplace;
      button.classList.toggle('azb__btn--primary', isPrimary);
    }
  }

  function updateOneButton(root, marketplace, info, variantId) {
    if (!info) {
      return;
    }
    var button = root.querySelector('.azb__btn--' + marketplace);
    if (!button) {
      return;
    }
    var asin = info.asin || '';
    var isFallback = !!info.fallback || !asin;
    var href;
    var label;

    if (isFallback) {
      href = root.getAttribute('data-search-' + marketplace);
      label = root.getAttribute('data-label-' + marketplace + '-fallback');
    } else {
      var domain = marketplace === 'ca' ? 'amazon.ca' : 'amazon.com';
      href = 'https://www.' + domain + '/dp/' + encodeURIComponent(asin);
      label = root.getAttribute('data-label-' + marketplace);
    }

    button.setAttribute('href', href || '#');
    if (label) {
      button.textContent = label;
    }
    button.setAttribute('data-asin', asin);
    button.setAttribute('data-variant-id', String(variantId));
  }

  function updateButtons(root, variantId) {
    var data = root._sewpheeAmazonData || {};
    var variant = data[String(variantId)];
    if (!variant) {
      return;
    }
    root.setAttribute('data-current-variant-id', String(variantId));
    updateOneButton(root, 'ca', variant.ca, variantId);
    updateOneButton(root, 'us', variant.us, variantId);
  }

  function bindClicks(root) {
    var buttons = root.querySelectorAll(CTA_SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (event) {
        var marketplace = event.currentTarget.getAttribute('data-marketplace');
        if (!marketplace) {
          return;
        }
        setStoredMarketplace(marketplace);
        applyPrimary(root, marketplace);
      });
    }
  }

  function bindVariantChange(root) {
    // This theme uses Dawn's pubsub, not a DOM CustomEvent. Verified against the
    // live assets on 2026-09-07:
    //   constants.js  → PUB_SUB_EVENTS.variantChange === 'variant-change'
    //   product-info.js → publish(PUB_SUB_EVENTS.variantChange,
    //                             { data: { sectionId, html, variant } })
    // So the payload is event.data.variant, not event.detail.variant.
    if (typeof window.subscribe === 'function') {
      var eventName =
        (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) || 'variant-change';
      window.subscribe(eventName, function (event) {
        var payload = (event && event.data) || {};
        var variant = payload.variant;
        if (!variant || !variant.id) {
          // Variant unavailable for the chosen options — leave the last good links up.
          return;
        }
        updateButtons(root, variant.id);
      });
      return;
    }

    // pubsub.js absent (block rendered outside a product context, or script
    // order changed). Fall back to a DOM event so the swap degrades rather
    // than silently doing nothing.
    var scope = root.closest('product-info') || document;
    scope.addEventListener('variant:change', function (event) {
      var variant = (event.detail || {}).variant;
      if (!variant || !variant.id) {
        return;
      }
      updateButtons(root, variant.id);
    });
  }

  function initInstance(root) {
    root._sewpheeAmazonData = parseVariantData(root);

    var marketplace = getStoredMarketplace() || defaultFromCountry(root.getAttribute('data-country-iso'));
    applyPrimary(root, marketplace);

    bindClicks(root);
    bindVariantChange(root);
  }

  function init() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    for (var i = 0; i < roots.length; i++) {
      initInstance(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
